export const companyScheduleFormFeild = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'select',
		title: 'Company Name',
		placeholder: 'select company',
		formControlName: 'selectCompany',
		required: true,
		errorsMsg: [{ type: 'required', message: 'select company' }],
	},
	{
		type: 'datetime-local',
		title: 'Start Time (Please use your local timezone)',
		placeholder: 'Start Time',
		formControlName: 'jobFairDate',
		required: true,
		errorsMsg: [{ type: 'required', message: 'Start Date is required' }],
	},
	{
		type: 'datetime-local',
		title: 'End Time (Please use your local timezone)',
		placeholder: 'End Time',
		formControlName: 'endDate',
		required: true,
		dateRangeValidator: 'jobFairDate',
		errorsMsg: [
			{ type: 'required', message: 'JobFair End Date is required' },
			{
				type: 'dateRangeValidator',
				message: 'End time is less than start time',
			},
		],
	},
];
